import React, { Component } from 'react';
import PT from 'prop-types';
import { snakeCase } from 'lodash';
import { ReactFormFieldList } from './reactformfieldlist';
import { getObjectPropertyValue } from './util';

export class ReactForm extends Component {

    render() {
        const formName = getObjectPropertyValue(this.props.form, 'name', this.props.lang);
        let uniqKeyFormfieldList = snakeCase(formName);
        if(this.props.ticketInfo) {
            uniqKeyFormfieldList += "_" + this.props.ticketInfo.id;
        }
        return (
            <ReactFormFieldList 
                key={uniqKeyFormfieldList} 
                fields={this.props.form.fields}
                formValues={this.props.filledForm}
                formInfoSupp={this.props.infoSupp}
                validationErrors={this.props.validationErrors} 
                onChange={this.props.onChange} 
                showValidationErrors={this.props.showValidationErrors}
                viewProvider={this.props.viewProvider}
                validator={this.props.validator}
                indentation={this.props.form.indentation}
                lang={this.props.lang}
            />
        );
    }
}

ReactForm.propTypes = {
    // Static stuff
    form: PT.object.isRequired, // The form definition (see doc)   
    viewProvider: PT.shape({
        getEmailInputView: PT.function, // () => ReactFormControlViews.EmailInputView
        getDateCombosView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getRadioButtonView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getCheckboxView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getCheckboxWithTextInputView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getDropdownView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getSimpleTextFieldView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getMultilineView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getMultipleItemsView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getMultipleDocumentsView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getFormContainerView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getFormChildrenView: PT.function, // () => ReactFormControlViews.DateCombosView        
        getFormFieldListView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getFormGroupWrapperView: PT.function, // () => ReactFormControlViews.DateCombosView    
        getJsonEditorView: PT.function, // () => ReactFormControlViews.DateCombosView
    }),

    // Working stuff
    onChange: PT.func.isRequired,
    filledForm: PT.object.isRequired, // The data object generated/edited by this form
    validationErrors: PT.object.isRequired,

    // Other stuff
    infoSupp: PT.array, // Ex.: {[{name:"ticketCode",label:"Code du billet",value:"L1273490454365"}]}
    ticketInfo: PT.object,
    validator: PT.func,
    showValidationErrors: PT.bool,
    lang: PT.string
};
